'use client'

import { useNotificationsContext } from 'notifications/hooks/useNotificationsContext/useNotificationsContext'

export const NotificationsSlot = () => {
	const { Notification } = useNotificationsContext()

	return Notification
}
